import { MenuItem } from '@chakra-ui/react'
import { FC } from 'react'
import { GrDocumentCsv } from 'react-icons/gr'

import useConciliation from '@hook/budget/user-conciliation'
import useTools from '@hook/shared/use-tools'

import { ILayoutToolsExportAction } from '@base/@types/components/Layout/Tools'
const ActionExcelConciliationAnalitcExport: FC<ILayoutToolsExportAction> =
  () => {
    const { isDisabled } = useTools()
    const { exportDataAnalitc } = useConciliation()
    return (
      <MenuItem
        p="2px 12px"
        fontSize="sm"
        bgColor="white"
        _hover={{ bg: 'gray.400' }}
        isDisabled={isDisabled}
        onClick={exportDataAnalitc}
        icon={<GrDocumentCsv />}
      >
        Exportar Analitico para CSV
      </MenuItem>
    )
  }

export default ActionExcelConciliationAnalitcExport
